var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { sortMarketGroupsByKey } from "../../helpers/";
import { getAllOutrightsTab } from "../../helpers";
export class MarketGroupsGateway {
    constructor(gateway, queryFactory, mapper, isAllOutrightsTabFirst) {
        this.gateway = gateway;
        this.queryFactory = queryFactory;
        this.mapper = mapper;
        this.isAllOutrightsTabFirst = isAllOutrightsTabFirst;
    }
    GetMarketGroups(leagueId, allOutrightsPhrase) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = this.queryFactory(leagueId);
            let response;
            try {
                response = yield this.gateway.getOutrightsByLeagueId(request);
            }
            catch (err) {
                response = {
                    marketTypes: []
                };
            }
            const mappedData = response.marketTypes.map(data => this.mapper.map(data, leagueId));
            if (response.marketTypes.length > 1) {
                mappedData.push(getAllOutrightsTab(leagueId, this.isAllOutrightsTabFirst, allOutrightsPhrase));
            }
            return mappedData.sort(sortMarketGroupsByKey);
        });
    }
}
//# sourceMappingURL=MarketGroupsGateway.js.map